import React from "react";
import { useTheme } from "../context/ThemeContext";

type TextFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  placeholder?: string;
  style?: React.CSSProperties;
  UpperCase?: boolean;
};

const CodeReaderField: React.FC<TextFieldProps> = ({
  label,
  value,
  onChange,
  onSubmit,
  placeholder,
  style = {},
  UpperCase = false,
}) => {
  const width = style.width ?? "100%";

  const handleChange = (raw: string) => {
    const v = UpperCase ? raw.toUpperCase() : raw;
    onChange(v);
  };

  const { theme, departmentColor } = useTheme();
  const primaryColor =
    departmentColor || theme?.primary_button || theme?.primary || "#0a343d";

  return (
    <div style={{ marginTop: "25px", marginLeft: style.marginLeft ?? 0 }}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            width: "100px",
            height: "43px",
            backgroundColor: "#D9D9D9",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            border: "1px solid #8A8A8A",
            borderRight: "none",
          }}
        >
          QR Code
        </div>

        <input
          type="text"
          value={UpperCase ? (value ?? "").toUpperCase() : value}
          onChange={(e) => handleChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && onSubmit) onSubmit();
          }}
          placeholder={placeholder}
          style={{
            width: width,
            height: "45px",
            borderTop: "1px solid #8A8A8A",
            borderBottom: "1px solid #8A8A8A",
            borderLeft: "none",
            borderRight: "none",
            padding: "0 8px",
            fontSize: "14px",
            outline: "none",
            boxSizing: "border-box",
            textTransform: UpperCase ? "uppercase" : "none",
          }}
        />

        <div
          onClick={onSubmit}
          style={{
            width: "100px",
            height: "43px",
            backgroundColor: primaryColor,
            color: "#fff",
            fontSize: "14px",
            fontFamily: "Inter, sans-serif",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            border: `1px solid ${primaryColor}`,
            borderLeft: "none",
          }}
        >
          Enviar
        </div>
      </div>
    </div>
  );
};

export default CodeReaderField;
